import React from 'react';
import {HPV_SUBSIDY_QR_URL} from '../data/hpvSubsidy';
import styles from './HpvSubsidyModal.module.css';

const HpvSubsidyModal = ({onClose}) => (
    <div className={styles.backdrop} role="presentation" onMouseDown={onClose}>
        <div
            className={styles.dialog}
            role="dialog"
            aria-modal="true"
            aria-labelledby="hpv-subsidy-title"
            onMouseDown={(event) => event.stopPropagation()}
        >
            <button
                type="button"
                className={styles.closeButton}
                onClick={onClose}
                aria-label="关闭领取红包提示"
            >
                ×
            </button>
            <h2 id="hpv-subsidy-title">领取红包</h2>
            <p>请保存下方二维码，在微信中打开后即可领取红包。</p>
            <img
                className={styles.qrCode}
                src={HPV_SUBSIDY_QR_URL}
                alt="领取 HPV 问答红包的二维码"
            />
            <p className={styles.tip}>可长按或保存二维码，再打开微信扫一扫识别。</p>
        </div>
    </div>
);

export default HpvSubsidyModal;
